import { Injectable } from '@angular/core';
import { FormControl, UntypedFormGroup } from '@angular/forms';
import { addDays } from 'date-fns';
import { map, startWith } from 'rxjs';

@Injectable()
export class DateFieldsHandlerService {
  isEndDateNextDayStream(
    form: UntypedFormGroup,
    startDateControl: FormControl<Date | null>,
    endDateControl: FormControl<Date | null>,
  ) {
    return form.valueChanges.pipe(
      startWith({}),
      map(() =>
        this.isEndDateNextDay(startDateControl.value, endDateControl.value),
      ),
    );
  }

  setCorrectStartEndDateTime({
    startDateTime,
    originalStartDateTime,
    endDateTime,
  }: {
    startDateTime: Date | null | undefined;
    originalStartDateTime: string;
    endDateTime: Date | null | undefined;
  }): {
    startDateTime: string;
    endDateTime: string;
  } {
    return {
      startDateTime: startDateTime
        ? this.setCorrectDateTime({
            time: startDateTime,
            originalDate: originalStartDateTime,
          })
        : '',
      endDateTime: endDateTime
        ? this.setCorrectDateTime({
            time: endDateTime,
            originalDate: originalStartDateTime,
            isNextDay: this.isEndDateNextDay(startDateTime, endDateTime),
          })
        : '',
    };
  }

  private setCorrectDateTime({
    time,
    originalDate: originalStartDatetime,
    isNextDay,
  }: {
    time: Date;
    originalDate: string;
    isNextDay?: boolean;
  }): string {
    let clonedDate = new Date(originalStartDatetime);

    if (isNextDay) {
      clonedDate = addDays(clonedDate, 1);
    }

    clonedDate.setHours(time.getHours());
    clonedDate.setMinutes(time.getMinutes());
    clonedDate.setSeconds(0);
    clonedDate.setMilliseconds(0);

    return clonedDate.toISOString();
  }

  private isEndDateNextDay(
    startDateTime: Date | null | undefined,
    endDateTime: Date | null | undefined,
  ): boolean {
    if (!startDateTime || !endDateTime) {
      return false;
    }

    const startMinutes =
      startDateTime.getHours() * 60 + startDateTime.getMinutes();
    const endMinutes = endDateTime.getHours() * 60 + endDateTime.getMinutes();

    return endMinutes < startMinutes;
  }
}
